export default import.meta.ROLLUP_FILE_URL_hf1H1kx$;